import { SubscriptionPolicy } from "./SubscriptionPolicy";

class SubscriptionService {

    static getLimits(plan) {

        return (
            SubscriptionPolicy[plan] ??
            SubscriptionPolicy.free
        );

    }

    static getLimit(plan, feature) {

        const limits = this.getLimits(plan);

        return limits[feature];

    }

    static canUse(plan, feature, currentCount = 0) {

        const limit = this.getLimit(
            plan,
            feature
        );

        return currentCount < limit;

    }

    static remaining(plan, feature, currentCount = 0) {

        const limit = this.getLimit(
            plan,
            feature
        );

        if (limit === Number.MAX_SAFE_INTEGER) {

            return Number.MAX_SAFE_INTEGER;

        }

        return Math.max(
            0,
            limit - currentCount
        );

    }

}

export default SubscriptionService;